const no = {
  pleaseEnterUsername: "Vennligst skriv inn et brukernavn",
  cannotFriendYourself: "Du kan ikke sende en venneforespørsel til deg selv.",
  friendRequestSent: "Venneforespørsel sendt!",
  failedToSendRequest: "Kunne ikke sende forespørselen",
  linkCopied: "Lenken er kopiert til utklippstavlen!",
  backToInvites: "Tilbake til invitasjoner",
  sendFriendRequestByUsername: "Send venneforespørsel med brukernavn",
  enterUsername: "Skriv inn brukernavn",
  send: "Send",
  yourInviteQrCode: "Din invitasjons-QR-kode",
  inviteLink: "Invitasjonslenke",
  scanQrOrUseLink: "Skann denne QR-koden eller bruk denne lenken for å sende en venneforespørsel",
  copyInviteLink: "Kopier invitasjonslenke",
  goToItem: "Gå til element",
  verificationEmailSent: "Bekreftelsesepost sendt! Sjekk innboksen din.",
  verificationEmailFailed: "Kunne ikke sende bekreftelsesepost. Prøv igjen.",
  verifyYourEmail: "Bekreft e-postadressen din",
  verifyEmailInstructions: "Bekreft e-postadressen din for å få tilgang til kontoen din. Sjekk innboksen din for bekreftelseslenken.",
  sending: "Sender...",
  resendVerificationEmail: "Send bekreftelsesepost på nytt",
  login: "Logg inn",
  register: "Registrer deg",
  home: "Hjem",
  calendar: "Kalender",
  friends: "Venner",
  profile: "Profil",
  logout: "Logg ut",
  loading: "Laster...",
  language: "Språk",
  calendarSelectPlaceSuggestion: "Velg et sted fra forslagene slik at koordinatene blir lagt til.",
  calendarSelectDateAndTime: "Velg dato og klokkeslett.",
  calendarPositiveDuration: "Oppgi en positiv varighet.",
  calendarFutureDateRequired: "Dato og klokkeslett for arrangementet må være i fremtiden.",
  calendarCreateEventFailed: "Kunne ikke opprette arrangementet. Prøv igjen.",
  cancel: "Avbryt",
  createNewEvent: "Opprett nytt arrangement",
  week: "Uke",
  month: "Måned",
  eventTitle: "Tittel",
  date: "Dato",
  time: "Klokkeslett",
  duration: "Varighet",
  endsAt: "Slutter kl.",
  place: "Sted",
  searchForPlace: "Søk etter et sted",
  placeSearchTip: "Tips: Begynn å skrive og velg et resultat for å legge til koordinater.",
  description: "Beskrivelse",
  createEvent: "Opprett arrangement",
  today: "I dag",
  previousMonth: "Forrige måned",
  nextMonth: "Neste måned",
  previous: "Forrige",
  next: "Neste",
  mondayShort: "Man",
  tuesdayShort: "Tir",
  wednesdayShort: "Ons",
  thursdayShort: "Tor",
  fridayShort: "Fre",
  saturdayShort: "Lør",
  sundayShort: "Søn",
  more: "mer",
  mustRespondWillBeforeReposting: "Du må svare \"Skal delta\" før du kan dele på nytt",
  event: "Arrangement",
  backToCalendar: "Tilbake til kalender",
  addToGoogleCalendar: "Legg til i Google Kalender",
  when: "Når",
  where: "Hvor",
  openLocationInGoogleMaps: "Åpne plasseringen i Google Maps",
  hosts: "Verter",
  yourResponse: "Ditt svar",
  currentResponse: "Nåværende svar",
  response_will: "Skal delta",
  response_might: "Kanskje delta",
  response_wont: "Skal ikke delta",
  willRunIntoYou: "Jeg stikker innom",
  mightDropBy: "Jeg stikker kanskje innom",
  wontCome: "Jeg kommer ikke",
  repostToMyFriends: "Del på nytt med vennene mine",
  responses: "Svar",
  willAttend: "Skal delta",
  reposted: "Delt på nytt",
  mightAttend: "Kanskje delta",
  cancelEvent: "Avlys arrangement",
  cancellationEmailNoticeBefore: "Personer som har svart at de kommer",
  cancellationEmailNoticeAfter: "vil få en e-post om avlysningen.",
  optionalCancellationMessage: "Valgfri melding til deltakerne (maks 1000 tegn)",
  confirmCancelEvent: "Bekreft avlysning av arrangement",
  clear: "Tøm",
  confirmCancellation: "Bekreft avlysning",
  confirmCancellationMessage: "Er du sikker på at du vil avlyse dette arrangementet? Dette vil varsle bekreftede deltakere og fjerne arrangementet.",
  eventCancelledNotified: "Arrangement avlyst. Varslet",
  attendees: "deltakere",
  failedToCancelEvent: "Kunne ikke avlyse arrangementet",
  back: "Tilbake",
  cancelled: "Avlyst",
  ok: "OK",
  forgotPassword: "Glemt passord",
  email: "E-post",
  passwordResetLinkSent: "Hvis kontoen finnes, er en lenke for tilbakestilling sendt.",
  passwordResetRequestFailed: "Kunne ikke be om tilbakestilling av passord.",
  sendResetLink: "Send tilbakestillingslenke",
  addFriend: "Legg til venn",
  incomingRequests: "Innkommende forespørsler",
  accept: "Godta",
  deny: "Avslå",
  myFriends: "Mine venner",
  noFriendsYet: "Du har ingen venner ennå. Begynn å legge til noen!",
  seeProfile: "Se profil",
  noEventsToRespondTo: "Ingen arrangementer å svare på",
  allCaughtUp: "Alt er oppdatert. Kom tilbake senere for nye arrangementer fra vennene dine.",
  events: "Arrangementer",
  unknown: "Ukjent",
  noDescriptionProvided: "Ingen beskrivelse oppgitt.",
  will: "Ja",
  maybe: "Kanskje",
  wont: "Nei",
  userNotFound: "Bruker ikke funnet",
  friendRequestSentSuccessfully: "Venneforespørsel sendt!",
  friendInvitation: "Venneinvitasjon",
  sendFriendRequest: "Send venneforespørsel",
  loginToSendFriendRequest: "Logg inn for å sende en venneforespørsel",
  chooseLanguage: "Velg språk",
  invalidCredentials: "Ugyldige innloggingsopplysninger. Prøv igjen.",
  username: "Brukernavn",
  password: "Passord",
  forgotPasswordQuestion: "Glemt passordet?",
  dontHaveAccount: "Har du ikke en konto?",
  registerHere: "Registrer deg her",
  invalidProfilePhotoType: "Ugyldig filtype. Last opp et JPEG-, PNG-, GIF- eller WebP-bilde.",
  invalidFileExtension: "Ugyldig filendelse",
  allowedExtensions: "Tillatt",
  fileTooLarge: "Filen er for stor",
  maximumFileSize: "Maksimum",
  profilePhotoRemoved: "Profilbildet ble fjernet.",
  failedToRemoveProfilePhoto: "Kunne ikke fjerne profilbildet",
  profileUpdatedSuccessfully: "Profilen ble oppdatert!",
  failedToUpdateProfile: "Kunne ikke oppdatere profilen",
  privateEmailExplanation: "Bare du kan se e-postadressen din for å unngå uønskede meldinger utenfor plattformen",
  yourEmailIsPrivate: "E-postadressen din er privat.",
  profilePhoto: "Profilbilde",
  removePhoto: "Fjern bilde",
  firstName: "Fornavn",
  lastName: "Etternavn",
  tellPeopleAboutYourself: "Fortell litt om deg selv",
  whereToContactMe: "Hvordan kontakte meg",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Lagre",
  notSet: "Ikke angitt",
  editProfile: "Rediger profil",
  imageToCrop: "Bilde som skal beskjæres",
  zoom: "Zoom",
  usePhoto: "Bruk bilde",
  name: "Navn",
  whereToContact: "Kontaktinformasjon",
  removeFriendship: "Fjern vennskap",
  confirmRemoveFriend: "Bekreft fjerning av venn",
  confirmRemoveFriendBefore: "Er du sikker på at du vil fjerne",
  confirmRemoveFriendAfter: "fra vennelisten din?",
  friendRemoved: "Venn fjernet.",
  failedToRemoveFriend: "Kunne ikke fjerne venn.",
  confirmRemove: "Bekreft fjerning",
  error: "Feil",
  removed: "Fjernet",
  passwordsDoNotMatch: "Passordene stemmer ikke overens",
  registrationFailed: "Registreringen mislyktes. Prøv igjen.",
  confirmPassword: "Bekreft passord",
  alreadyHaveAccount: "Har du allerede en konto?",
  loginHere: "Logg inn her",
  passwordResetSuccessfully: "Passordet ble tilbakestilt.",
  failedToResetPassword: "Kunne ikke tilbakestille passordet.",
  resetPassword: "Tilbakestill passord",
  newPassword: "Nytt passord",
  confirmNewPassword: "Bekreft nytt passord",
  setNewPassword: "Angi nytt passord",
  emailVerifiedSuccessfully: "E-postadressen er bekreftet!",
  emailVerificationFailed: "Bekreftelsen mislyktes. Lenken kan være ugyldig eller utløpt.",
  verifying: "Bekrefter...",
  verified: "Bekreftet!",
  redirectingToHome: "Sender deg til startsiden...",
  verificationFailed: "Bekreftelsen mislyktes",
  goToHome: "Gå til startsiden",
  about: "Om",
  aboutConceptTitle: "Konsept",
  aboutCreatorIntroduction: "Hei, jeg er Crypt0, klatrer og skaperen av Run Into Me.",
  aboutCreatorStory: "Jeg laget nettstedet fordi jeg er sosial og brukte for mye tid på å organisere klatreøkter med andre.",
  aboutPlanningProblem: "Jeg ønsket å fortelle alle samtidig når og hvor jeg skulle klatre, uten en formell invitasjon.",
  aboutDeveloperSolution: "Da husket jeg at jeg er utvikler og kunne lage løsningen selv.",
  aboutWelcome: "Velkommen til Run Into Me, der du forteller venner om aktiviteter de kan bli med på uten press.",
  aboutCallToAction: "Publiser den neste aktiviteten som er morsommere sammen, her!",
  aboutTutorialTitle: "Veiledning",
  aboutCalendarCreateEvent: "I kalendervisningen kan du også opprette en ny hendelse.",
  aboutEventColorsIntroduction: "Fargene viser deltakelsesstatus:",
  aboutColorGold: "Gull",
  aboutColorGoldDescription: "Du arrangerer hendelsen.",
  aboutColorGreen: "Grønn",
  aboutColorGreenDescription: "Du deltar på hendelsen.",
  aboutColorOrange: "Oransje",
  aboutColorOrangeDescription: "Du svarte «kanskje».",
  aboutColorBlue: "Blå",
  aboutColorBlueDescription: "Du har ikke svart ennå.",
  aboutColorGray: "Grå",
  aboutColorGrayDescription: "Du avslo invitasjonen.",
  aboutCalendarEventDetails: "Klikk på en hendelse for detaljer og svar.",
  aboutFriendPageTitle: "Venneside",
  aboutFriendPageDescription: "Skriv inn brukernavn eller send invitasjonslenke / QR-kode.",
  aboutHomePageTitle: "Startside",
  aboutHomePageDescription: "Se kommende hendelser og oppgi om du kommer.",
  aboutRepostScreenTitle: "Skjerm for videreformidling",
  aboutGoogleCalendarDescription: "Legg hendelsen til i Google Kalender med denne knappen.",
  aboutRepostDescription: "Etter bekreftet deltakelse kan du dele hendelsen med venner.",
};

export default no;